import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=122758f4&"
import script from "./ImageViewer.vue?vue&type=script&lang=ts&"
export * from "./ImageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports